module.exports = __webpack_public_path__ + "image/demo_1_2_97d19.png";